/**
 * Demo Mode Hook
 * Manages demo mode state and initialization
 * Only initializes demo data when explicitly in demo mode
 */

import { useEffect, useState } from 'react';
import { useMode } from '@/providers/ModeProvider';
import { demoDataService } from '../services/demo/demo-data.service';

export function useDemoMode() {
  const { mode } = useMode();
  const isDemoMode = mode === 'demo';
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (isDemoMode && !isInitialized) {
      // Initialize demo data only when explicitly in demo mode
      demoDataService.initialize();
      setIsInitialized(true);
    }
  }, [isDemoMode, isInitialized]);

  return {
    isDemoMode,
    isInitialized,
  };
}
